import _ from 'underscore';
import {
  DEFAULT_GRID_CONFIG,
} from '@bingads-webui-campaign-react/asset-library-components';

export const FOLDER_GRID_CONFIG = { ...DEFAULT_GRID_CONFIG, aspectRatio: undefined, rowHeight: 100 };

// null means loading
export const isSectionDataLoadingStatus =
  sectionData => _.every(sectionData, ({ items }) => items == null);

// [] means loaded, but no data
export const isSectionDataEmptyStatus =
  (sectionData) => {
    const anySectionLoaded = _.any(sectionData, ({ items }) => !!items);

    return anySectionLoaded && _.every(sectionData, ({ items }) => _.isEmpty(items));
  };
